import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
// Placeholder imports for pages we are about to build
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Experience } from './pages/Experience';
import { Leadership } from './pages/Leadership';
import { BoardService } from './pages/BoardService';
import { Speaking } from './pages/Speaking';
import { Credentials } from './pages/Credentials';
import { Contact } from './pages/Contact';
import { Media } from './pages/Media';
import { SuccessStories } from './pages/SuccessStories';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/about" element={<About data-id="element-6" />} data-id="element-5" />
          <Route path="/experience" element={<Experience data-id="element-8" />} data-id="element-7" />
          <Route path="/leadership" element={<Leadership data-id="element-10" />} data-id="element-9" />
          <Route path="/board" element={<BoardService data-id="element-12" />} data-id="element-11" />
          <Route path="/speaking" element={<Speaking data-id="element-14" />} data-id="element-13" />
          <Route path="/credentials" element={<Credentials data-id="element-16" />} data-id="element-15" />
          <Route path="/contact" element={<Contact data-id="element-18" />} data-id="element-17" />
          <Route path="/media" element={<Media data-id="element-20" />} data-id="element-19" />
          <Route path="/success-stories" element={<SuccessStories data-id="element-22" />} data-id="element-21" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}